export enum Shops {
  Streetfood = 1,
  Togo = 2,
}
